/** Parent asks to drop a whole mail or flyer. One line stays a separate action. */

export const FORGET_COPY = {
  noMail: "Ich habe keine Eltern-Mail zum Löschen.",
  noFlyer: "Ich habe keinen Flyer zum Löschen.",
  keptMail: "Alles klar — die Mail bleibt.",
  keptFlyer: "Alles klar — der Flyer bleibt.",
  deletedMail: "Mail gelöscht.",
  deletedFlyer: "Flyer gelöscht.",
  restoredMail: "Die Mail ist wieder da.",
  restoredFlyer: "Der Flyer ist wieder da.",
  undo: "Rückgängig",
  delete: "Löschen",
  keep: "Behalten",
  irrelevant: "Nicht relevant",
  confirmDelete: "Löschen",
  confirmCancel: "Abbrechen",
};

function normalize(text) {
  return String(text || "")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * @param {string} text
 * @returns {{ kind: 'mail'|'capture' } | null}
 */
export function parseExtractionForgetIntent(text) {
  const t = normalize(text);
  if (!t) return null;
  const flyer = /\b(flyer|foto|zettel|aushang)\b/.test(t);
  const mail = /\b(mail|email|e mail|elternbrief)\b/.test(t);
  const forget =
    /\b(nicht fur uns|loschen|loeschen|vergiss|ignorier)\b/.test(t) ||
    t.includes("weg damit") ||
    t.includes("nicht relevant");
  if (!forget || (!flyer && !mail)) return null;
  if (flyer && !mail) return { kind: "capture" };
  if (mail && !flyer) return { kind: "mail" };
  const flyerAt = t.search(/\b(flyer|foto|zettel|aushang)\b/);
  const mailAt = t.search(/\b(mail|email|elternbrief)\b/);
  return { kind: flyerAt > mailAt ? "capture" : "mail" };
}

function joinNames(names) {
  const list = (names || []).map((name) => String(name || "").trim()).filter(Boolean);
  if (list.length === 0) return "";
  if (list.length === 1) return list[0];
  if (list.length === 2) return `${list[0]} und ${list[1]}`;
  return `${list.slice(0, -1).join(", ")} und ${list[list.length - 1]}`;
}

/**
 * Confirm copy before a whole-source delete.
 * @param {{ kind: 'mail'|'capture', subject?: string|null, titles?: string[] }} params
 */
export function forgetConfirmText({ kind, subject, titles } = {}) {
  const label = String(subject || "").trim();
  const lead = label
    ? `${label} löschen?`
    : kind === "capture"
      ? "Diesen Flyer löschen?"
      : "Diese Mail löschen?";
  const names = joinNames((titles || []).slice(0, 3));
  const tail = names
    ? `Dann sind ${names} auch weg.`
    : "Dann sind die Termine daraus auch weg.";
  return `${lead}\n${tail}`;
}

/**
 * @param {{ kind: 'mail'|'capture', id: string, subject?: string|null, titles?: string[], makeId: () => string }} params
 */
export function forgetConfirmMessage({ kind, id, subject, titles, makeId }) {
  return {
    text: forgetConfirmText({ kind, subject, titles }),
    options: [
      {
        id: makeId(),
        label: FORGET_COPY.delete,
        kind: "forget-extraction",
        value: { kind, id, subject: subject || null },
      },
      {
        id: makeId(),
        label: FORGET_COPY.keep,
        kind: "keep-extraction",
        value: kind,
      },
    ],
  };
}
